import { push } from 'redux-first-history';
import queryString from 'query-string';
import get from 'lodash.get';
import {
    fetchEnrollmentData as fetchSharedEnrollmentData,
    fetchSharedAdditionalEnrollmentInfo,
} from '../shared/enrollmentActions';
import ReadingEnrollmentClient from '../../clients/reading/EnrollmentClient';
import EspanolEnrollmentClient from '../../clients/espanol/EnrollmentClient';
import BurstClient from '../../clients/reading/BurstClient';
import InterventionClient from '../../clients/reading/InterventionClient';
import { getUrlString } from '../../../utils/shared/urlUtils';
import { selectors } from '../../../root/reading/root';
import { LICENSE } from '../../../constants/reading/CommonConstants';
import { PARAM } from '../../../constants/reading/ApiConstants';
import KeycloakClient from '../../clients/shared/KeycloakClient';

const { BURST } = LICENSE;

const updateStudentsWithTempInstId = (burstData, enrollmentResponse) => {
    const mergedStudentsByGrade = burstData.studentsByGrade?.map(gradeData => {
        const existingGradeData =
            enrollmentResponse?.enrollmentData?.studentsByGrade?.find(
                item => item.grade === gradeData.grade,
            ) ?? {};

        return {
            ...gradeData,
            students: gradeData.students.map(student => {
                const existingStudent =
                    existingGradeData.students?.find(
                        item => item.externalId === student.externalId,
                    ) || {};
                return {
                    ...student,
                    temporalInstId: existingStudent.temporalInstId,
                };
            }),
        };
    });

    return {
        ...enrollmentResponse,
        enrollmentData: {
            ...get(enrollmentResponse, 'enrollmentData', {}),
            studentsByGrade: mergedStudentsByGrade,
        },
    };
};

const fetchD8EnrollmentInfo = async params => {
    const { burstGroupUid } = params;
    const data = await ReadingEnrollmentClient.getEnrollmentInfo(params);
    const licensingInfo = get(data, 'enrollmentData.licensingConfiguration.licensingInfo', []);
    if (licensingInfo.includes(BURST) && burstGroupUid) {
        const burstData = await BurstClient.getBurstStudents(burstGroupUid);

        return updateStudentsWithTempInstId(burstData, data);
    }
    const isMasUser = KeycloakClient.isMasUser();
    if (!isMasUser && burstGroupUid) {
        const burstData = await InterventionClient.getInterventionStudents(burstGroupUid);
        return updateStudentsWithTempInstId(burstData, data);
    }
    return data;
};

export const fetchEnrollmentData =
    (district, school, classe, period, burstGroupUid) => async dispatch => {
        const params = {
            [PARAM.DISTRICT]: district,
            [PARAM.SCHOOL]: school,
            [PARAM.CLASSE]: classe,
            [PARAM.PERIOD]: period,
            [PARAM.BURST_GROUP_UID]: burstGroupUid,
        };
        await dispatch(fetchSharedEnrollmentData(params, fetchD8EnrollmentInfo));
    };

export const fetchAdditionalEnrollmentData = () => async dispatch => {
    await dispatch(
        fetchSharedAdditionalEnrollmentInfo(EspanolEnrollmentClient.getAdditionalEnrollmentInfo),
    );
};

export const updateEnrollmentUrl = () => (dispatch, getState) => {
    const state = getState();
    const { pathname, search } = selectors.getLocation(state);
    dispatch(
        push(
            getUrlString(pathname, {
                ...queryString.parse(search),
                ...selectors.getEnrollmentInfo(state),
                period: selectors.getSelectedPeriod(state),
            }),
        ),
    );
};
